import { Budget } from "../../types";
import { getStatusButtonText, getButtonBackgroundColor } from "../utils";
import useDarkMode from "../../../../hooks/useDarkMode";

interface CardActionsProps {
  budget: Budget;
  onViewHistory?: (budgetId: string) => void;
  onAction?: (budgetId: string, action: string) => void;
  buttonBg: string;
  buttonText: string;
  buttonHover: string;
}

const CardActions = ({
  budget,
  onViewHistory,
  onAction,
  buttonBg,
  buttonText,
  buttonHover,
}: CardActionsProps) => {
  const isDarkMode = useDarkMode();
  const buttonBackgroundColor = getButtonBackgroundColor(budget.status, isDarkMode);

  return (
    <div className="flex flex-col mt-4">
      <button
        onClick={() => onViewHistory?.(budget.id)}
        className="text-size-14 text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 underline mb-2 text-left"
      >
        Ver histórico de atualizações
      </button>
      <button
        onClick={() => onAction?.(budget.id, budget.status)}
        className={`bg-[#FFFFFF] dark:bg-neutral-900 w-full text-center py-1.5 rounded-full font-medium ${buttonBg} ${buttonText} ${buttonHover} transition-colors duration-200`}
        style={buttonBackgroundColor ? { backgroundColor: buttonBackgroundColor } : undefined}
      >
        {getStatusButtonText(budget)}
      </button>
    </div>
  );
};

export default CardActions;



